export function getVideoWidthHeightRatio(src: string): Promise<number> {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.muted = true;
        video.playsInline = true;

        video.onloadedmetadata = () => {
            const {videoWidth, videoHeight} = video;
            video.removeAttribute('src');
            video.load();

            if (!videoWidth || !videoHeight) {
                reject(new Error('Unable to read video dimensions'));
                return;
            }

            resolve(videoWidth / videoHeight);
        };

        video.onerror = () => {
            reject(new Error('Failed to load video metadata'));
        };

        video.src = src;
    });
}
